import { render, staticRenderFns } from "./SidebarSubmenu.vue?vue&type=template&id=6f927d8a&scoped=true&"
import script from "./SidebarSubmenu.vue?vue&type=script&lang=ts&"
export * from "./SidebarSubmenu.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarSubmenu.vue?vue&type=style&index=0&id=6f927d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f927d8a",
  null
  
)

export default component.exports